import { render, staticRenderFns } from "./BeneficialOwnersRegistry.vue?vue&type=template&id=70de8e0f&scoped=true&"
import script from "./BeneficialOwnersRegistry.vue?vue&type=script&lang=js&"
export * from "./BeneficialOwnersRegistry.vue?vue&type=script&lang=js&"
import style0 from "./BeneficialOwnersRegistry.vue?vue&type=style&index=0&id=70de8e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de8e0f",
  null
  
)

export default component.exports